import { promocodeTypes } from "redux/reducers/promocode/promocodeTypes"
import { formatPromocode } from "redux/reducers/promocode/promocodeReducer"

import { PROYECT, api_get, api_delete, api_post, api_put } from "services/api"

import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions"

const {
    GET_PROMOCODES,
    NEW_PROMOCODE,
    SET_PROMOCODE_FILTERS,
    SET_BRANDS,
    SET_SELECTED_PROMOCODE,
    DELETE_PROMOCODE,
    UPDATE_PROMOCODE
} = promocodeTypes

const url = `${process.env.REACT_APP_URL}${PROYECT}/coupons`

export const getPromocodes = (station) => {
    let paramsString = ''

    if (station && station.value) paramsString += `?idStation=${station.value}`

    return async dispatch => {
        dispatch(startRequestComp('loadingPromocodes'))
        await api_get(url + paramsString).then(resp => {
            dispatch({
                type: GET_PROMOCODES,
                payload: {
                    promocodes: resp.coupons.map(formatPromocode)
                }
            })
        }).catch(error => {
            dispatch(setSnackbar(error?.message?.error || 'Error', 'danger'))
        }).finally(() => {
            dispatch(stopRequestComp('loadingPromocodes'))
        })
    }
}

export const createPromocode = (data, cb) => {
    return async dispatch => {
        dispatch(startRequestComp('createPromocode'))
        await api_post(url, data).then(resp => {
            dispatch({
                type: NEW_PROMOCODE,
                payload: resp.coupon
            })

            dispatch(setSnackbar('Cupón creado correctamente', 'success'))
            dispatch(setSelectedPromocode({ promocode: {}, addMode: true }))

            if (cb) cb()
        }).catch(error => {
            dispatch(setSnackbar(error || 'Error', 'danger'))
        }).finally(() => {
            dispatch(stopRequestComp('createPromocode'))
        })
    }
}

export const editPromocode = (data, cb) => {
    return async dispatch => {
        dispatch(startRequestComp('editPromocode'))
        await api_put(`${url}/${data.id}`, data).then(resp => {
            dispatch({
                type: UPDATE_PROMOCODE,
                payload: resp.coupon
            })

            dispatch(setSnackbar('Cupón editado correctamente', 'success'))

            if (cb) cb()
        }).catch(error => {
            dispatch(setSnackbar(error || 'Error', 'danger'))
        }).finally(() => {
            dispatch(stopRequestComp('editPromocode'))
        })
    }
}

export const deletePromocode = (id, cb) => {
    return async dispatch => {
        dispatch(startRequestComp('deletePromocode'))
        await api_delete(url + `/${id}`).then(() => {
            dispatch({
                type: DELETE_PROMOCODE,
                payload: id
            })

            dispatch(setSnackbar('Cupón eliminado correctamente', 'success'))
            dispatch(setSelectedPromocode({ promocode: {}, addMode: true }))

            if (cb) cb()
        }).catch(error => {
            dispatch(setSnackbar(error || 'Error', 'danger'))
        }).finally(() => {
            dispatch(stopRequestComp('deletePromocode'))
        })
    }
}

export const setSelectedPromocode = (promocode) => ({
    type: SET_SELECTED_PROMOCODE,
    payload: promocode
})

export const setPromocodeFilters = (key = "", data) => ({
    type: SET_PROMOCODE_FILTERS,
    payload: { data, key }
})


export const setStationBrands = (brands) => ({
    type: SET_BRANDS,
    payload: brands
})